import { Omega } from '@/plugins/plugin-init-omega/index';
import { env } from '@/utils';
import { useAppStore } from '@/store';

// 新系统 0/1 旧系统 2新系统
const NEW_SYSTEM = 2;
// 共用数据集合
let getCollectData = {};
// 静态资源加载时间
let LOAD_TIME_TEMP = 0;
// performance计算加特兰静态资源时间
const { navigationStart, requestStart } = window.performance.timing;
let LOAD_HTML_TIME = {
  start: requestStart,
  end: navigationStart,
  time: requestStart - navigationStart,
};
// 走缓存时间
let NO_TIME = {
  start: 0,
  end: 0,
  time: 0,
};
// 微应用加载时长
const MICRO_LOAD_TIME = () => {
  const store = useAppStore();
  // 获取主应用跳转起始时间和子应用加载完毕时间
  const { startTime, endTime, microStartTime } = store.$state.loadTime;
  const loadTime = {
    // 子应用内部切换时不会调起基座的路由守卫，因此内部切换使用子应用的路由守卫时间
    start: startTime ? startTime : microStartTime,
    end: endTime,
    time: startTime ? endTime - startTime : endTime - microStartTime,
  };
  // 清空上一次的数据
  store.$state.loadTime = {};
  // 缓存静态资源加载时间
  LOAD_TIME_TEMP = loadTime.time;
  return loadTime;
};
// 微应用渲染时长
const MICRO_RENDER_TIME = () => {
  // 点击导航时间
  const { entry_time } = getCollectData;
  return {
    start: entry_time,
    end: new Date().getTime(),
    time: new Date().getTime() - entry_time,
  };
};
// 点击类型
export const CLICK_TYPE = {
  ASIDE: 0, // 侧边栏
  WROKSHOP: 1, // 首页
  TOP: 2, // 顶部
  OTHER: 3, // 其它
  SUMMARY: 4, // 概览
  TOP_NAV: 5, // 顶部菜单导航
};
// 当前URL
export const getCurrentUrl = () => {
  return window.location.href.split('?')[0];
};
// 加特兰埋点所需公共参数
export const gtrTrackCommonData = () => {
  const userInfo = env.get('userInfo');
  const { job, dept, country, username } = userInfo;
  const currentUrl = getCurrentUrl();
  return {
    job,
    dept,
    country,
    username,
    current_url: currentUrl,
    url: currentUrl,
    system: NEW_SYSTEM,
  };
};
/**
 * 收集加特兰埋点相关公共数据 工具
 * 示例 gtrCollectTrackCommonData({user: ''})
 * @param data
 */
export const gtrCollectTrackCommonData = (data) => {
  const store = useAppStore();
  getCollectData = { module: { ...store.$state.moduleInfo }, ...getCollectData, ...data };
  return getCollectData;
};
/**
 * 加特兰曝光埋点
 * @param {params: 页面属性} params
 * @returns null
 * 使用示例
 * gtrTrackSW({ name: '我的申请', nodeId: 12 })
 */
export const gtrTrackSW = (params) => {
  // getCollectData在每次上报完后会清空，如果没切换页面，getCollectData不会存入数据，由此可判断路由是否发生变化，防止在同一页面重复上报埋点问题
  if (!Object.keys(getCollectData).length) return;
  const trackSW = Omega.trackEvent('sailing_m_gtr_general_sw', '页面曝光', {
    ...formatTrackParams({ ...getCollectData, ...params }),
    ...gtrTrackCommonData(),
  });
  // 上报完埋点后清空通用数据
  getCollectData = {};
  return trackSW;
};
/**
 * 加特兰点击埋点
 * @param {params: 页面属性} params
 * @returns null
 * 使用示例
 * gtrTrackCK({ name: '我的申请', nodeId: 12 })
 */
export const gtrTrackCK = (params) => {
  const { name, nodeId = '', click_type = CLICK_TYPE.OTHER } = params;
  return Omega.trackEvent('sailing_m_gtr_general_ck', '点击事件', {
    ...gtrTrackCommonData(),
    module: {
      name,
      nodeId,
    },
    click_type,
  });
};
/**
 * 加特兰登录用时埋点
 * @param {params: { loginStartTime: 1, loginReadyTime: 2 } } params
 * @returns null
 * 使用示例
 * gtrTrackCK({ loginSuccessTime: 123 })
 */
export const gtrTrackLogin = (params) => {
  const { loginStartTime, loginReadyTime } = params;
  return Omega.trackEvent('tech_sailing_m_gtr_general_unlogin_to_login_time_sw', '用户未登录到登录时长曝光', {
    ...gtrTrackCommonData(),
    loginTime: {
      start: loginStartTime,
      endTime: loginReadyTime,
      time: loginReadyTime - loginStartTime,
    },
  });
};
/**
 * 格式化埋点数据
 * @param { module: {}, ... } params
 * @returns {module: {}, ... } 埋点所需的所有数据
 */
const formatTrackParams = (params) => {
  const { module = {}, entry_type = CLICK_TYPE.OTHER, request_end_time, isSPA = false, isMicro = true } = params;
  // 记录上一条访问url
  let preUrl = sessionStorage.getItem('pre_url') || '/home';
  sessionStorage.setItem('pre_url', window.location.href.split('?')[0]);
  const store = useAppStore();
  // 获取主应用跳转起始时间和子应用加载完毕时间
  const { startTime, endTime } = store.$state.loadTime;
  return {
    module,
    pre_url: preUrl,
    // 如果是微应用，取通用数据里面的entry_type，fix从链接点开或刷新子应用时通用数据里entry_type为空
    entry_type: isMicro ? (getCollectData.entry_type ? getCollectData.entry_type : CLICK_TYPE.OTHER) : entry_type,
    // 如果是SPA应用，加载、请求、渲染时间为0
    load_html_time: isSPA ? NO_TIME : isMicro ? MICRO_LOAD_TIME() : LOAD_HTML_TIME,
    // 如果是SPA应用，加载、请求、渲染时间为0, 如果是微应用，加载、请求时间为0
    request_time:
      isSPA || isMicro
        ? NO_TIME
        : {
            start: LOAD_HTML_TIME.end,
            end: request_end_time,
            time: request_end_time - LOAD_HTML_TIME.end,
          },
    // 微应用，渲染时间为业务回调时间 - 用户点击模块时间
    render_time: isSPA
      ? NO_TIME
      : isMicro
      ? MICRO_RENDER_TIME()
      : {
          start: request_end_time,
          end: new Date().getTime(),
          time: new Date().getTime() - request_end_time,
        },
    load_html_total_time: isSPA ? NO_TIME.time : isMicro ? LOAD_TIME_TEMP : LOAD_HTML_TIME.time,
    userinfo_total_time: isSPA || isMicro ? NO_TIME.time : request_end_time - LOAD_HTML_TIME.end,
    render_total_time: isSPA ? NO_TIME.time : isMicro ? MICRO_RENDER_TIME().time : new Date().getTime() - request_end_time,
  };
};
